import './pre-bootstrap';

import 'bootstrap';

// Loading jQuery via the webpack 'expose-loader' is equivalent to importing it here
// import "jquery";

import "core-js/stable";
import "regenerator-runtime/runtime";

import "jquery-ui/ui/version.js";
import "jquery-ui/ui/widget.js";
import "jquery-ui/ui/data.js";
import "jquery-ui/ui/disable-selection.js";
import "jquery-ui/ui/focusable.js";
import "jquery-ui/ui/keycode.js";
import "jquery-ui/ui/labels.js";
import "jquery-ui/ui/plugin.js";
import "jquery-ui/ui/scroll-parent.js";
import "jquery-ui/ui/tabbable.js";
import "jquery-ui/ui/unique-id.js";
import "jquery-ui/ui/effect.js";
import "jquery-ui/ui/effects/effect-blind.js";
import "jquery-ui/ui/effects/effect-bounce.js";
import "jquery-ui/ui/effects/effect-clip.js";
import "jquery-ui/ui/effects/effect-drop.js";
import "jquery-ui/ui/effects/effect-explode.js";
import "jquery-ui/ui/effects/effect-fade.js";
import "jquery-ui/ui/effects/effect-fold.js";
import "jquery-ui/ui/effects/effect-highlight.js";
import "jquery-ui/ui/effects/effect-puff.js";
import "jquery-ui/ui/effects/effect-pulsate.js";
import "jquery-ui/ui/effects/effect-scale.js";
import "jquery-ui/ui/effects/effect-shake.js";
import "jquery-ui/ui/effects/effect-size.js";
import "jquery-ui/ui/effects/effect-slide.js";
import "jquery-ui/ui/effects/effect-transfer.js";
import "jquery-ui/ui/widgets/mouse.js";
import "jquery-ui/ui/widgets/tabs.js";
import "jquery-ui/ui/widgets/spinner.js";
import "jquery-ui/ui/widgets/sortable.js";
import "jquery-ui/ui/widgets/accordion.js";
import "jquery-ui/ui/widgets/autocomplete.js";
import "jquery-ui/ui/widgets/controlgroup.js";
import "jquery-ui/ui/widgets/button.js";
import "jquery-ui/ui/form-reset-mixin.js";
import "jquery-ui/ui/widgets/checkboxradio.js";
import "jquery-ui/ui/widgets/datepicker.js";
import "jquery-ui/ui/widgets/dialog.js";
import "./overrides/jquery-ui/ui/widgets/jquery.dialogOptions.js";
import "jquery-ui/ui/widgets/draggable.js";
import "jquery-ui/ui/widgets/droppable.js";
import "jquery-ui/ui/widgets/menu.js";
import "jquery-ui/ui/widgets/progressbar.js";
import "jquery-ui/ui/widgets/resizable.js";
import "jquery-ui/ui/widgets/selectable.js";
import "jquery-ui/ui/widgets/selectmenu.js";
import "jquery-ui/ui/widgets/slider.js";

import './Esearcher/index.js';
import './handler-tabs-main';
import "./unsaved-changes-alert.js";
import './ajax';
import './chunk-load-error-handler.js';
import './widgetLoader';
import "./notify";
import "./namespace";
import "./jquery-extensions";
import "./browser-compatibility";
import "./box";
import "./bootstrap";
import "./search-list/activity";
import "./locale/change-language";
import "./layouts/modern/tooltip";
import "./layouts/modern/dashboard";
import "./layouts/modern/select";
import "./register-pages";
import "./register-layouts"

import './vue3';

navigator.serviceWorker.getRegistration('/service-worker.js').then((registration) => {
    if (!registration) {
        navigator.serviceWorker.register('/service-worker.js', { scope: '/' });
    }
});

if (module.hot) {
    module.hot.accept();
}
